import "./myExperience.scss";
import React from "react";
import MyExperienceRouter from "./routes";
import UiTheme from "shared/enums/UiTheme";
import { ThemeProvider } from "context/theme";
import { AuthProvider } from "shared/context/auth";
import { StaticDataProvider } from "context/staticData";
import { RegDetailProvider, useRegDetail } from "shared/context/regDetail";
import FeatureControlCheck from "../../shared/components/featureControlCheck";
import SetSentryContext from "shared/sentry";
import { CommonFeaturesProvider } from "../../context/commonFeatures";
import { ParticipantDetailContextProvider } from "./context/participantDetails";
import { MyExpAnalyticsProvider } from "./context/analyticsWrapper";
import { FEATURE_CONTROL_WHITELISTED_ROUTES_FOR_MOBILE } from "shared/utils/constants";
import { EnabledFeatureContextProvider } from "./context/enabledFeatures";

export default function MyExperience() {
  return (
    <RegDetailProvider>
      <MyExperienceWrapper />
    </RegDetailProvider>
  );
}

function MyExperienceWrapper() {
  const regDetail = useRegDetail();
  React.useEffect(() => {
    window.document.title = regDetail.name;
  }, [regDetail.name]);

  return (
    <StaticDataProvider localeId={regDetail.localeId}>
      <CommonFeaturesProvider>
        <ThemeProvider clientTheme={UiTheme[regDetail.theme]}>
          <FeatureControlCheck
            isMobileSupported={false}
            isTabletSupported={false}
            headerLogo={regDetail.logoUrl}
            whiteListedRoutesForMobile={FEATURE_CONTROL_WHITELISTED_ROUTES_FOR_MOBILE}
            mobileAppLinks={{
              appStoreLink: regDetail.appStoreLink,
              playStoreLink: regDetail.playStoreLink
            }}>
            <AuthProvider>
              <SetSentryContext />
              <ParticipantDetailContextProvider>
                <EnabledFeatureContextProvider>
                  <MyExpAnalyticsProvider>
                    <MyExperienceRouter />
                  </MyExpAnalyticsProvider>
                </EnabledFeatureContextProvider>
              </ParticipantDetailContextProvider>
            </AuthProvider>
          </FeatureControlCheck>
        </ThemeProvider>
      </CommonFeaturesProvider>
    </StaticDataProvider>
  );
}
